module.exports = __webpack_public_path__ + "fonts/iconfont.35b00c05.eot";